import { Box } from "@chakra-ui/react";
import { colors } from "goi_common";
import { BaseStack } from "../../layout";
import { BaseBadge } from "../../components";

export interface TabItem<T = string> {
  label: string;
  value: T;
  badge?: string;
}

export interface SegmentedControlProps<T = string> {
  tabs: TabItem<T>[];
  selectedValue: T;
  onTabChange: (value: T) => void;
}

export function SegmentedControl<T extends string>({
  tabs,
  selectedValue,
  onTabChange,
}: SegmentedControlProps<T>) {
  return (
    <BaseStack
      direction="horizontal"
      spacing={0}
      css={{
        width: "100%",
        height: "40px",
        background: colors.gray50,
        borderRadius: "6px",
        padding: "2px",
        gap: "1px",
      }}
    >
      {tabs.map((tab) => {
        const isSelected = selectedValue === tab.value;

        return (
          <Box
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            css={{
              flex: 1,
              height: "36px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              borderRadius: "4px",
              cursor: "pointer",
              background: isSelected ? colors.white : "transparent",
              boxShadow: isSelected
                ? "0px 1px 4px rgba(0,0,0,0.08), 0px 0px 2px rgba(0,0,0,0.12)"
                : "none",
              transition: "all 0.2s ease",
            }}
          >
            <span
              className={isSelected ? "body_16_m gray900" : "body_16_r"}
              css={{
                color: isSelected ? colors.gray900 : colors.gray500,
              }}
            >
              {tab.label}
            </span>
            {tab.badge && <BaseBadge>{tab.badge}</BaseBadge>}
          </Box>
        );
      })}
    </BaseStack>
  );
}
